import React from 'react';
import './Projects.css';

const Projects = () => {
  const projects = [
    {
      id: '01',
      name: 'Location Entropy Analysis',
      description: 'Taxi mobility pattern analysis',
      technologies: 'Python · Jupyter · Pandas',
      category: 'Data Analysis',
      liveLink: 'https://github.com/jericho0521/Location-Entropy-Analysis',
    },
    {
      id: '02',
      name: 'Customer Personality Analysis',
      description: 'Customer segmentation',
      technologies: 'Scala · SQL · Spark',
      category: 'Data Analysis',
      liveLink: 'Customer Personality Analysis Code (2).html',
    },
    {
      id: '03',
      name: 'Project Play By CW',
      description: 'Gaming center website',
      technologies: 'React · CSS · JS',
      category: 'Web Development',
      liveLink: 'https://ppbycw.com/',
    },
    {
      id: '04',
      name: 'Project Power By CW',
      description: 'Engineering solutions website',
      technologies: 'React · CSS · JS',
      category: 'Web Development',
      liveLink: 'https://projectpowerbycw.com/',
    },
  ];

  return (
    <section className="projects">
      <div className="projects-inner">
        <h1 className="page-title">Work</h1>
        <div className="projects-list">
          {projects.map((project) => (
            <div key={project.id} className="project-row">
              <div className="project-divider"></div>
              <div className="project-content">
                <span className="project-number">{project.id}</span>
                <div className="project-info">
                  <div className="project-main">
                    <span className="project-name">{project.name}</span>
                    <span className="project-category">{project.category}</span>
                  </div>
                  <div className="project-sub">
                    <span className="project-description">{project.description}</span>
                    <span className="project-tech">{project.technologies}</span>
                  </div>
                </div>
                <a
                  href={project.liveLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-link"
                >
                  View ↗
                </a>
              </div>
            </div>
          ))}
          <div className="project-divider"></div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
